"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagesApi = exports.PageCode = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var PageCode;
(function (PageCode) {
    PageCode["Advertisement"] = "advertisement";
    PageCode["LegalNotice"] = "legalNotice";
    PageCode["Faq"] = "faq";
    PageCode["ForecastTransparency"] = "forecastTransparency";
    PageCode["OurPartners"] = "ourPartners";
    PageCode["Tos"] = "tos";
    PageCode["PrivacyPolicy"] = "privacyPolicy";
    PageCode["SiteMap"] = "siteMap";
})(PageCode = exports.PageCode || (exports.PageCode = {}));
function PagesApiAxiosParamCreator(configuration) {
    return {
        getPage(pageCode, options = {}) {
            if (pageCode === null || pageCode === undefined) {
                throw new base_1.RequiredError("pageCode", "Required parameter pageCode was null or undefined when calling getPage.");
            }
            const localVarPath = `/pages/{pageCode}`.replace(`{${"pageCode"}}`, encodeURIComponent(String(pageCode)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function PagesApiFp(configuration) {
    return {
        getPage(pageCode, options) {
            const localVarAxiosArgs = PagesApiAxiosParamCreator(configuration).getPage(pageCode, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class PagesApi extends base_1.BaseAPI {
    getPage(pageCode, options) {
        return PagesApiFp(this.configuration).getPage(pageCode, options)(this.axios, this.basePath);
    }
}
exports.PagesApi = PagesApi;
